import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=2da40268&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=ts&"
export * from "./MyDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=2da40268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da40268",
  null
  
)

export default component.exports